import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  IAnalogIOExtenderList,
  IGen2IOExtenderList,
  INormalIOExtenderList,
} from '../models/io-extender';

@Injectable({
  providedIn: 'root',
})
export class ExtIo {
  private baseUrl: string = `${environment.apiUrl}/io-ext`;
  private http: HttpClient = inject(HttpClient);

  // Signals for state
  normalIOExtenders = signal<INormalIOExtenderList | null>(null);
  normalIOExtendersRequired = computed(() => {
    const value = this.normalIOExtenders();
    if (!value) {
      return null;
    }
    return value;
  });

  analogIOExtenders = signal<IAnalogIOExtenderList | null>(null);
  analogIOExtendersRequired = computed(() => {
    const value = this.analogIOExtenders();
    if (!value) {
      return null;
    }
    return value;
  });

  gen2IOExtenders = signal<IGen2IOExtenderList | null>(null);
  gen2IOExtendersRequired = computed(() => {
    const value = this.gen2IOExtenders();
    if (!value) {
      return null;
    }
    return value;
  });

  isLoading = signal(false);
  errorMessage = signal('');

  getNormalIOExtenders(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<INormalIOExtenderList>(
        `${this.baseUrl}/controller/${controllerId}/normal`
      )
      .subscribe({
        next: (data) => {
          this.normalIOExtenders.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load normal io ext.');
          this.isLoading.set(false);
        },
      });
  }

  updateNormalFromSocket(data: INormalIOExtenderList) {
    this.normalIOExtenders.set(data);
  }

  getAnalogIOExtenders(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IAnalogIOExtenderList>(
        `${this.baseUrl}/controller/${controllerId}/analog`
      )
      .subscribe({
        next: (data) => {
          this.analogIOExtenders.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load analog io ext.');
          this.isLoading.set(false);
        },
      });
  }

  updateAnalogFromSocket(data: IAnalogIOExtenderList) {
    this.analogIOExtenders.set(data);
  }

  getGen2IOExtenders(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IGen2IOExtenderList>(
        `${this.baseUrl}/controller/${controllerId}/gen2`
      )
      .subscribe({
        next: (data) => {
          this.gen2IOExtenders.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load gen2 io ext.');
          this.isLoading.set(false);
        },
      });
  }

  updateGen2FromSocket(data: IGen2IOExtenderList) {
    this.gen2IOExtenders.set(data);
  }
}
